<style lang="scss" scoped>
.layout {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;

	::v-deep .el-header {
		background-color: #fff;
		color: #333;
		line-height: 60px;
	}

	::v-deep .el-aside {
		color: #fff;
		overflow-x: hidden;
		background-color: #2b3752;
		width: auto !important;
	}

	::v-deep .el-menu {
		border-right: none;
	}

	::v-deep .el-menu-item {
		background-color: #212b44 !important;
	}

	::v-deep .el-menu-item.is-active {
		background-color: #1b2131 !important;
	}

	.logo {
		height: 60px;
		line-height: 60px;
		padding: 0 20px;
		width: 100%;
		font-size: 16px;
		@include common-box-sizing();
	}

	.l-header-right {
		float: right;
	}

	.l-header-left {
		height: 100%;
		float: left;
		i {
			font-size: 24px;
			color: #666;
			cursor: pointer;
			line-height: 60px;
		}
	}

	::v-deep .el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 200px;
		min-height: 400px;
	}

	::v-deep .el-main {
		padding: 10px;
	}

	.l-main-tabs {
		::v-deep .el-tabs__header {
			margin: 0;
		}

		::v-deep .el-tabs__item {
			background: #fff;
			border-bottom: solid 1px #e4e7ed;
		}
		::v-deep .is-active {
			background: transparent;
			border-bottom-color: #f5f7f9 !important;
		}
	}

	.l-avater-wrapper {
		line-height: 1.5;
		display: inline-block;
		vertical-align: middle;
		margin-right: 10px;
	}
}
</style>
<template>
	<div class="layout">
		<el-container style="height: 100%">
			<el-aside>
				<div class="logo">
					<img src="../../assets/images/logo.png" style="width: 30px; vertical-align: middle" />
					<span v-show="!isCollapsed" style="vertical-align: middle"> 物资点检管理系统 </span>
				</div>
				<el-menu
					@open="onMenuOpen"
					:default-openeds="op"
					:default-active="active_menu_id"
					router
					@select="selectMenu"
					class="el-menu-vertical-demo"
					background-color="#2b3752"
					text-color="#fff"
					active-text-color="#ffd04b"
					:collapse="isCollapsed"
				>
					<el-submenu :index="item.id.toString()" v-for="item in menu_tree" :key="item.id" v-show="item.children.length > 0">
						<template slot="title">
							<i v-html="item.icon"></i>
							<span v-text="item.menu_name"></span>
						</template>
						<el-menu-item :index="citem.id.toString()" v-for="citem in item.children" :key="citem.id" :route="getRoute(citem.route)">
							<span v-text="citem.menu_name"></span>
						</el-menu-item>
					</el-submenu>
				</el-menu>
			</el-aside>

			<el-container>
				<el-header style="font-size: 12px">
					<div class="l-header-left">
						<i class="el-icon-s-fold" v-show="!isCollapsed" @click="onCollapsed"></i>
						<i class="el-icon-s-unfold" v-show="isCollapsed" @click="onCollapsed"></i>
					</div>
					<div style="vertical-align: middle; float: left; margin-left: 15px; font-size: 16px" v-if="userinfo.company_id">
						<!-- {{ userinfo.role_info.name }}
						<el-dropdown @command="changeCompany">
							<span class="el-dropdown-link">
								<img
									src="@/assets/images/qiehuan.png"
									style="height: 18px; vertical-align: middle; margin-bottom: 3px"
									v-if="company_list.length > 1"
								/>
							</span>	
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item v-for="item in company_list" :key="item.id" :command="item.id">{{ item.name }}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown> -->
					</div>

					<div class="l-header-right">
						<div class="l-avater-wrapper">
							<el-avatar size="medium" :src="userinfo.avatar">
								<i class="el-icon-user-solid" />
							</el-avatar>
						</div>
						<el-dropdown @command="dropdownCommand">
							<i class="el-icon-caret-bottom" style="cursor: pointer; font-size: 18px"></i>
							<el-dropdown-menu slot="dropdown">
								<!-- <el-dropdown-item  command="showUserinfo"><i class="el-icon-info" style="color:#409EFF" />用户信息</el-dropdown-item> -->
								<el-dropdown-item command="changePwd"><i class="el-icon-unlock" style="color: #e6a23c" />修改密码</el-dropdown-item>
								<el-dropdown-item command="logout"><i class="el-icon-switch-button" style="color: #f56c6c" />退出登录</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</el-header>

				<el-tabs class="l-main-tabs" type="card" v-model="active_menu_id" @tab-click="tabChange" @tab-remove="closeTab">
					<el-tab-pane :key="item.id" v-for="item in tabs" :label="item.menu_name" :closable="item.id != -1" :name="item.id.toString()">
					</el-tab-pane>
				</el-tabs>

				<el-main ref="main">
					<!-- <keep-alive> -->
					<router-view />
					<!-- </keep-alive> -->
				</el-main>
			</el-container>
		</el-container>

		<!--弹出修改密码-->
		<l-dialog :visible.sync="show_pwd" title="修改密码">
			<user-change-pwd :visible.sync="show_pwd" @on-success="show_pwd = false"></user-change-pwd>
		</l-dialog>
	</div>
</template>

<script>
import store from "@/utils/store";
import store2 from "@/store/index";
import UserChangePwd from "@/views/user/ChangePwd";
import { LIST } from "@/store/actions";

import Vue from "vue";
export default {
	name: "admin",
	components: {
		[UserChangePwd.name]: UserChangePwd,
	},
	data() {
		return {
			isCollapsed: false,
			menu_list: [
				{
					id: "-1",
					menu_name: "首页",
					route: "/admin/home",
					path: "",
				},
			],
			menu_tree: [],
			tabs: this.$store.state.breadcrumb,
			active_menu_id: "-1",
			op: [],

			userinfo: {},
			show_userinfo: false,
			company_list: [],
			misc_type_list: [],

			websock: false,

			task_count: 0,
			backlog_data: [],
			backlog_count: 0,
			backlog_page: 1,
			backlog_page_size: 30,
			backlog_page_count: 0,
			backlog_loading: false,
			show_backlog: false,

			show_pwd: false, //是否显示修改密码弹窗
		};
	},

	//路由进入前获取菜单数据
	beforeRouteEnter(to, from, next) {
		Vue.$_invoke("menu_getUserMenu").then((ret) => {
			next((vm) => {
				vm.menu_tree = ret.menu_tree;
				vm.menu_list = [...ret.menu_list, ...vm.menu_list];
				const active_menu = vm.menu_list.find((item) => {
					let { route } = item;
					route = route.search(/^\/.*/i) === -1 ? "/" + route : route;
					return to.path === route;
				});
				if (typeof active_menu != "undefined") {
					vm.$nextTick(() => {
						vm.active_menu_id = active_menu.id;
						vm.op = [active_menu.pid];
						vm.op = [`${active_menu.pid}`];
						vm.addTab(active_menu);
					});
				}
			});
		});
	},

	watch: {
		//监听路由变化
		$route(val) {
			const { path } = val;
			const menu = this.menu_list.find((item) => {
				return this.getRoute(item.route) == path;
			});
			if (typeof menu != "undefined") {
				this.active_menu_id = menu.id;
			}
		},
	},

	computed: {
		menuitemClasses: function() {
			return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
		},

		getBreadcrumb() {
			if (this.active_menu_id == -1) {
				return [];
			}
			const active_menu = this.menu_list.find((item) => {
				return item.id == this.active_menu_id;
			});
			let result = [];
			if (typeof active_menu != "undefined") {
				let path_ids = active_menu.path.split(">");
				path_ids.splice(0, 2);
				path_ids.splice(path_ids.length - 1, 1);
				path_ids.push(active_menu.id);
				path_ids.forEach((item) => {
					const index = this.menu_list.findIndex((menu) => {
						return item == menu.id;
					});
					if (index != -1) {
						result.push(this.menu_list[index]);
					}
				});
			}

			return result;
		},
	},

	mounted() {
		this.getUserInfo();
		this.getMiscTypeList();
	},

	methods: {
		// //初始化websocket
		// initWebSocket() {
		// 	//初始化weosocket
		// 	const wsuri = `ws://${Vue.$_config.websocket_host}`;
		// 	this.websock = new WebSocket(wsuri);
		// 	this.websock.onmessage = this.websocketOnMsg;
		// 	this.websock.onopen = this.websocketOnOpen;
		// 	this.websock.onerror = this.websocketOnErr;
		// 	this.websock.onclose = this.websocektOnClose;
		// },

		// //建立连接发送user_id
		// websocketOnOpen() {
		// 	// console.log("连接成功了");
		// 	let actions = { user_id: this.userinfo.id, socket_id: "uid" + this.userinfo.id + Math.ceil(Math.random() * 10) };
		// 	this.websock.send(JSON.stringify(actions));
		// },

		// //接收数据
		// websocketOnMsg(msg) {
		// 	let data = msg.data;
		// 	if (typeof data == "string" && data != "connect") {
		// 		data = JSON.parse(data);
		// 		if (Object.prototype.hasOwnProperty.call(data, "event")) {
		// 			switch (data.event) {
		// 				//待专家审核的任务数量
		// 				case "task_count":
		// 					this.task_count = data.count;
		// 					break;
		// 			}
		// 		}
		// 	}
		// },

		// //发生错误
		// websocketOnErr() {
		// 	// console.log("出错了");
		// },

		// //连接断开
		// websocektOnClose() {
		// 	// console.log("连接断开");
		// },

		//获取用户信息
		getUserInfo() {
			this.$_invoke("user_getUserinfo").then((ret) => {
				this.userinfo = ret.userinfo;
				this.company_list = ret.company_list;
			});
			store2.dispatch(LIST.NAMESPACE + "/" + LIST.REQUEST_LIST);
		},

        //获取综合编码类别
        getMiscTypeList() {
            this.$_invoke("miscCode_getTypeList").then((ret) => {
                this.misc_type_list = ret.data;
            });
            store2.dispatch(LIST.NAMESPACE + "/" + LIST.REQUEST_LIST);
        },

		//选择菜单时的处理事件
		selectMenu(id) {
			const menu_index = this.menu_list.findIndex((item) => {
				return item.id == id;
			});

			const curr_menu = this.menu_list[menu_index];

			this.addTab({
				id: curr_menu.id,
				menu_name: curr_menu.menu_name,
				route: curr_menu.route,
			});

			//找出父级ID并展开
			// this.onMenuOpen(curr_menu.pid.toString());
		},

		//收起/展开菜单
		onCollapsed() {
			this.isCollapsed = !this.isCollapsed;
		},

		//添加顶部tab
		addTab(data) {
			
			const index = this.tabs.findIndex((item) => {
				return item.id == data.id;
			});
			if (index == -1) {
				// this.tabs.push({ ...data });
				this.$store.commit("pushBreadcrumb", data);
			}
			this.active_menu_id = data.id.toString();
		},

		//关闭tab
		closeTab(id) {
			
			const index = this.tabs.findIndex((item) => {
				return item.id == id;
			});
			if (index != -1) {
				this.tabs.splice(index, 1);

				//如果是当前活跃的id自动跳转到前一个路由
				if (this.active_menu_id == id) {
					this.tabChange({ name: this.tabs[index - 1].id });
				}
			}
		},

		//打开菜单的回调
		onMenuOpen(index) {
			const i = this.op.findIndex((item) => {
				return index == item;
			});
			if (i == -1) {
				this.op.push(index);
			}
		},

		//获取格式好的路由，防止后台填写路由不完整
		getRoute(route) {
			return route.search(/^\/.*/i) === -1 ? "/" + route : route;
		},

		//点击顶部选项卡，切换路由
		tabChange(tab) {
			const { name: id } = tab;
			const index = this.tabs.findIndex((item) => {
				return item.id == id;
			});
			this.$router.push(this.getRoute(this.tabs[index].route));
			this.active_menu_id = id;
		},

		//点击右侧用户栏选项  
		clickDropdownItem(name) {
			this[name]();
		},

		//显示用户信息
		showUserinfo() {
			this.show_userinfo = true;
		},

		//退出登录
		logout() {
			this.$confirm("确定要退出登录吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				this.$_invoke("login_logout").then((ret) => {
					if (ret) {
						store.delete("token");
						location.href = "/login";
						//this.$router.push("/login");
					}
				});
			});
		},

		//点击右上角下拉菜单
		dropdownCommand(command) {
			switch (command) {
				case "logout":
					this.logout();
					break;
				case "changePwd":
					this.show_pwd = true;
					break;
			}
		},
	},
};
</script>

<style lang="scss" scoped></style>
